@use '@/flavours/glitch/styles/mastodon/mixins';
@use '@/flavours/glitch/styles/mastodon/variables';

.root {
  position: sticky;
  top: 0;
  z-index: 10;

  // Cover up outer borders on Column component
  margin-inline: calc(-1 * var(--bw-default));
  padding-top: var(--space-1);
  color: var(--color-text-primary);
  background: var(--color-bg-desktop);

  @media (width <= variables.$mobile-menu-breakpoint) {
    padding-top: 0;
    margin-inline: 0;
    background: var(--color-bg-primary);
  }

  // Scroll fade that overlays the scrollable content below
  &::after {
    content: '';
    pointer-events: none;
    position: absolute;
    top: 100%;
    inset-inline: 0;
    z-index: -1;
    height: var(--space-10);
    background: linear-gradient(
      to bottom,
      var(--color-bg-primary),
      transparent
    );
    transition:
      opacity,
      transform 250ms ease-out;

    @media (width > variables.$mobile-menu-breakpoint) {
      // Prevent fade from overlapping column border
      inset-inline: var(--bw-default);
    }
  }

  &.rootScrolledToTop::after {
    opacity: 0;
    transition-timing-function: ease-in;
    transform: translateY(calc(-1 * var(--space-6)));
  }
}

.layout {
  --column-header-padding: var(--space-3) var(--space-3) var(--space-1);

  position: relative;
  display: grid;

  // Ensure title is centered regardless of side-content
  grid-template-columns:
    minmax(min-content, 1fr)
    minmax(0, auto)
    minmax(min-content, 1fr);
  align-items: center;

  // Ensure that a header without buttons is as tall as one with buttons
  min-height: 48px;
  text-align: center;
  cursor: pointer;

  @media (width > variables.$mobile-menu-breakpoint) {
    background: var(--color-bg-primary);
    border: var(--border-column);
    border-bottom: none;
    border-radius: var(--radius-6) var(--radius-6) 0 0;
  }
}

.unreadButton {
  position: absolute;
  top: 100%;
  inset-inline: 0;
  margin-inline: auto;
  width: max-content;
  max-width: 100%;

  :global(body.layout-multiple-columns) & {
    margin-top: var(--space-1);
  }
}

.leftButton {
  grid-area: 1 / 1;
  justify-self: start;
  padding: var(--column-header-padding);
  cursor: default;
}

.rightButtons {
  grid-area: 1 / 3;
  display: flex;
  align-items: center;
  justify-self: end;
  padding: var(--column-header-padding);
  cursor: default;
}

.title {
  @include mixins.type-heading-sm;

  grid-area: 1 / 2;
  white-space: nowrap;
  min-width: 0;
  padding: var(--column-header-padding);

  > button {
    text-overflow: ellipsis;
    overflow: hidden;
    width: 100%;
    padding: 0;
    border: none;
    font: inherit;
    color: inherit;
    background: transparent;
    border-radius: var(--radius-2);

    &:focus-visible {
      outline: var(--outline-focus-default);
      outline-offset: 2px;
    }
  }
}

.extraStickyContent {
  background: var(--color-bg-primary);

  @media (width > variables.$mobile-menu-breakpoint) {
    border-inline: var(--border-column);
  }
}
